<template>
  <div
    style="padding: 15px"
    class="bg-white"
    label-position="top"
    v-loading="isLoading"
  >
    <el-row>
      <el-col :sm="12">
        <h4 class="form-title">Repair - CMM</h4>
      </el-col>
      <el-col :sm="12">
        <div class="d-flex justify-content-flex-end">
        <el-form
            class="text-right"
            :inline="true"
            @submit.native.prevent="fetch(1)"
            size="small"
          >
          <el-form-item>
            <el-input
              v-model="pager.q"
              placeholder="Search by ULD Part No."
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetch(1)">Search</el-button>
          </el-form-item>
          <el-button type="primary" size="small" @click="openDrawer"
            >Add CMM</el-button
          >
          <el-button size="small" type="primary" @click="download" >Download CMM</el-button>
          </el-form>  
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="data.data">
          <el-table-column label="Actions" width="80">
            <template slot-scope="scope">
              <el-button
                type="primary"
                icon="el-icon-edit"
                title="Edit information"
                circle
                size="small"
                @click="edit(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="ULD Part No."
            prop="part_name"
            width="120px"
          ></el-table-column>
          <el-table-column label="CMM No." prop="cmm_no"></el-table-column>
          <el-table-column width="100px" label="Revision Date" prop="rev_date">
            <template slot-scope="scope">{{
              scope.row.rev_date | dateFormat
            }}</template>
          </el-table-column>
          <el-table-column
            label="Revision Status"
            prop="rev_status"
            width="140px"
          ></el-table-column>
          <el-table-column
            label="Revision Description"
            prop="rev_desc"
            min-width="200px"
          ></el-table-column>
          <el-table-column
            label="Old Number"
            prop="old_number"
            width="120px"
          ></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row type="flex">
      <el-col :sm="24" :md="12">
        <el-pagination
          v-show="!isLoading"
          class="pt-1 pb-1"
          background
          layout="prev, pager, next"
          :total="data.paging.total"
          :page-size="pager.limit"
          :current-page="parseInt(data.paging.cur_page)"
          @current-change="fetch"
        ></el-pagination>
      </el-col>
      <el-col :sm="24" :md="12" class="text-right">
        <AppUploader
          class="mt-1"
          url="/api/v1/repair/upload/cmm/"
          accept=".csv"
          @beforeUpload="batch_beforeUpload"
          @uploadSuccess="batch_handleUploadSuccess"
          >Batch Upload</AppUploader
        >
      </el-col>
    </el-row>
    <el-drawer
      ref="drawer"
      size="45%"
      :visible.sync="viewDrawer"
      v-loading="isLoading"
      :destroy-on-close="true"
      @close="closeDrawer"
      :wrapperClosable="false"
    >
      <div class="el-drawer__content">
        <el-form ref="form" :model="formModel" :rules="rules">
          <el-form-item label="ULD Part No." prop="jo_part_id">
            <el-select v-model="formModel.jo_part_id" clearable filterable>
              <el-option
                v-for="item in spareParts"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-row :gutter="15">
            <el-col :sm="12">
              <el-form-item label="CMM No." prop="cmm_no">
                <el-input
                  v-model="formModel.cmm_no"
                  :readonly="formModel.id ? true : false"
                  :disabled="formModel.id ? true : false"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="12">
              <el-form-item label="Revision Date" prop="rev_date">
                <el-date-picker
                  type="date"
                  v-model="formModel.rev_date"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="Revision Status" prop="rev_status">
            <el-input v-model="formModel.rev_status"></el-input>
          </el-form-item>
          <el-form-item label="Revision Description" prop="rev_desc">
            <el-input v-model="formModel.rev_desc"></el-input>
          </el-form-item>
          <el-form-item label="File URL" prop="directory">
            <el-input v-model="formModel.directory"></el-input>
          </el-form-item>
          <!-- <el-row>
            <el-col :sm="12" v-if="!formModel.id && !formModel.directory">
              <el-form-item>
                <AppUploader
                  url="/api/v1/inventory/fileupload/"
                  :params="{ q: 'cmm' }"
                  accept="application/pdf"
                  @beforeUpload="beforeUpload"
                  @uploadSuccess="handleUploadSuccess"
                ></AppUploader>
              </el-form-item>
            </el-col>
            <el-col :sm="12" v-else>
              <a @click.prevent="viewDoc" href="#" title="View CMM">View CMM</a>
            </el-col>
          </el-row> -->
        </el-form>
        <div class="el-drawer__footer">
          <el-button size="small" type="primary" @click="save">Save</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import CMM from "@/models/CMM";
import SpareParts from "@/models/SpareParts";
import api from "@/api";
import moment from "moment";
export default {
  name: "CMM",
  beforeRouteLeave(to, from, next) {
    if (this.isLoading) alert("You have unsaved changes.");
    else next();
  },
  data() {
    return {
      formModel: new CMM(),
      spareParts: [],
      rules: {
        jo_part_id: [{ required: true, message: "Spare part is required." }],
        cmm_no: [{ required: true, message: "CMM No. is required." }],
        rev_date: [{ required: true, message: "Rev Date is required." }],
        rev_status: [{ required: true, message: "Rev Status is required." }],
        rev_desc: [{ required: true, message: "Rev Description is required." }]
      },
      data: { paging: {}, data: [] },
      isLoading: false,
      pager: {
        limit: 15
      },
      viewDrawer: false
    };
  },
  methods: {
    fetch(page) {
      this.isLoading = true;
      this.pager.page = 1;
      if (page) {
        this.pager.page = page;
      }
      CMM.list(this.pager).then(list => {
        this.isLoading = false;
        if (list) this.data = list;
      });
    },
    download() {
      var reportInfo = {
          name: "CMM",
          ext: ".csv"
      };
      let url = `/api/v1/repair/cmm/?limit=-1`
      api.download(url, reportInfo).then(() => {
          this.isLoading = false;
          this.btnDisable = false;
      });
    },
    edit(item) {
      this.viewDrawer = true;
      this.formModel = new CMM({
        id: item.id,
        jo_part_id: item.jo_part_id,
        cmm_no: item.cmm_no,
        rev_date: item.rev_date,
        rev_status: item.rev_status,
        rev_desc: item.rev_desc,
        directory: item.directory
      });
    },
    openDrawer() {
      this.viewDrawer = true;
    },
    closeDrawer() {
      this.formModel = new CMM();
    },
    save() {
      this.$confirm("Do you want to save the CMM information?")
        .then(() => {
          this.$refs.form.validate(valid => {
            if (!valid) return false;
            this.isLoading = true;
            this.formModel.rev_date = moment(this.formModel.rev_date).format(
              "YYYY-MM-DD"
            );
            if (this.formModel.id) {
              CMM.update(this.formModel).then(resp => {
                if (resp.code == 200) {
                  this.$refs.drawer.closeDrawer();
                  this.formModel = new CMM();
                  this.fetch();
                  this.isLoading = false;
                  this.$notify({
                    type: "success",
                    message: "Repair CMM information saved.",
                    position: "bottom-right"
                  });
                }
              });
            } else {
              CMM.store(this.formModel).then(resp => {
                this.isLoading = false;
                if (resp.code == 200) {
                  this.$notify({
                    type: "success",
                    message: "Repair CMM information saved.",
                    position: "bottom-right"
                  });
                  this.$refs.drawer.closeDrawer();
                  this.formModel = new CMM();
                  this.fetch();
                }
              });
            }
          });
        })
        .catch(() => {});
    },
    loadSpareParts() {
      this.spareParts = [];
      SpareParts.list({ limit: 99999 }).then(list => {
        this.spareParts = list.data;
      });
    },
    beforeUpload() {
      this.isLoading = true;
    },
    handleUploadSuccess(res, file) {
      // console.log(res);
      this.isLoading = false;
      if (
        res.hasOwnProperty("data") &&
        res.data.hasOwnProperty("code") &&
        res.data.code == 200
      ) {
        // console.log(file);
        let s = file.name.split(".");
        s.pop();
        this.formModel.cmm_no = s.join("");
        this.formModel.directory = res.data.msg;
      } else {
        this.$notify({
          type: "error",
          message: res.data.msg,
          position: "bottom-right"
        });
      }
    },
    viewDoc() {
      window.open(`/pdf-viewer/doc?type=cmm&id=${this.formModel.id}`, "_blank");
    },
    batch_beforeUpload() {
      this.isLoading = true;
    },
    batch_handleUploadSuccess(res) {
      this.isLoading = false;
      console.log(res);
      if (
        res.hasOwnProperty("data") &&
        res.data.hasOwnProperty("code") &&
        res.data.code == 200
      ) {
        this.fetch();
        this.$notify({
          type: "success",
          message: res.data.msg,
          position: "bottom-right"
        });
      } else {
        this.$notify({
          type: "error",
          message: res.data.msg,
          position: "bottom-right"
        });
      }
    }
  },
  created() {
    window.addEventListener("beforeunload", e => {
      if (this.isLoading) {
        e.preventDefault();
        event.returnValue = " ";
      }
    });
  },
  mounted() {
    this.fetch();
    this.loadSpareParts();
  }
};
</script>

<style lang="css" scoped></style>
